import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import { compose } from '../../services/utilityFunctions';
import withCSRF from '../../commonComponents/withCSRF';
import translate from '../../commonComponents/translate';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import TextFilter from '../../commonComponents/lists/filters/TextFilter';
import DateFilter from '../../commonComponents/lists/filters/DateFilter';
import SelectFilter from '../../commonComponents/lists/filters/SelectFilter';
import List from '../../commonComponents/lists/ClientSideList';
import OrderCompleteModal from './Components/OrderCompleteModal';

function OrdersList(props) {
  const [{ show: showOrderModal }, setShowOrderModal] = useState({
    show: false,
  });

  const onClick = () => setShowOrderModal({ show: true });
  const [query, setQuery] = useState({ search: '' });
  const setSearch = value => setQuery({ search: value });
  const orders = [
    {
      id: 1,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'onGoing',
    },
    {
      id: 2,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 3,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 4,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 5,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'onGoing',
    },
    {
      id: 6,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 7,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.57,
      total: 30,
      status: 'finished',
    },
    {
      id: 8,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 9,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'onGoing',
    },
    {
      id: 10,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.50,
      total: 30,
      status: 'finished',
    },
    {
      id: 11,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.59,
      total: 30,
      status: 'finished',
    },
    {
      id: 12,
      number: '123-122',
      date: '23-03-2020',
      price: 23.5,
      deliveryFee: 3.58,
      total: 30,
      status: 'finished',
    },
  ];
  const {
    t,
    _csrf,
  } = props;

  const categories = [
    {
      id: 'finished',
      text: 'Finished',
    },
    {
      id: 'on-going',
      text: 'On Going',
    },
  ];
  const columns = [
    {
      field: 'number',
      title: t('orders_list_number'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'date',
      title: t('orders_list_date'),
      textAlign: 'center',
    },
    {
      field: 'price',
      title: t('orders_list_price'),
      textAlign: 'center',
      sortable: false,
    },
    {
      field: 'status',
      title: t('orders_list_status'),
      textAlign: 'center',
      template(row) {
        const status = {
          onGoing: { title: 'Ongoing', class: 'status-onGoing' },
          finished: { title: 'Finished', class: 'status-finished' },
        };
        return `<a class="${status[row.status].class}" href="/orders/id">
                    ${status[row.status].title}
                </a>`;
      },
    },
    {
      field: 'Invoice',
      title: t('orders_list_invoice'),
      textAlign: 'center',
      sortable: false,
      template: () => renderToStaticMarkup(<a style={{ fontWeight: '600' }} href="#">{t('order_list_downloadInvoice')}</a>),
    },
  ];

  return (
    <Title title={t('orders_head_title')}>
      <ContentContainer>
        <SubHeader title={t('orders_title')} />
        <TopicBanner />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="orders-list_menu">
                    <div className="m-form m-form--label-align-right m--margin-top-20 m--margin-bottom-30 orders-top_menu">
                      <div className="row align-items-center">
                        <div className="col-xl-12 col-md-12 order-2 order-xl-1">
                          <div className="form-group m-form__group row align-items-center">
                            <div className="col-sm-3 col-md-3">
                              <TextFilter
                                onChange={setSearch}
                                placeholder={t('search_order')}
                              />
                            </div>
                            <div className="col-sm-3 col-md-3">
                              <DateFilter />
                            </div>
                            <div className="col-sm-3 col-md-3 select-order">
                              <SelectFilter
                                onChange={setSearch}
                                items={categories}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <List
                      loading={false}
                      data={orders}
                      id="ordersList"
                      columns={columns}
                      query={query}
                    />
                  </div>
                </div>
                <div className="order-complete_button">
                  <button type="button" className="btn m-btn--pill btn-secondary" onClick={onClick}>
                    Order Complete modal!
                  </button>
                </div>
                {showOrderModal &&
                <OrderCompleteModal
                  onClose={() => {
                    setShowOrderModal({ show: false });
                  }}
                />
                }
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

OrdersList.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
};

export default compose(
  translate,
  withCSRF,
)(OrdersList);
